<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4H9.7587C8.95374 3.99999 8.28937 3.99998 7.74818 4.04419C7.18608 4.09012 6.66937 4.18868 6.18404 4.43598C5.43139 4.81947 4.81947 5.43139 4.43598 6.18404C4.18868 6.66937 4.09012 7.18608 4.04419 7.74818C3.99998 8.28937 3.99999 8.95372 4 9.75869V17H6V9.8C6 8.94342 6.00078 8.36113 6.03755 7.91104C6.07337 7.47262 6.1383 7.24842 6.21799 7.09202C6.40973 6.7157 6.7157 6.40973 7.09202 6.21799C7.24842 6.1383 7.47262 6.07337 7.91104 6.03755C8.36113 6.00078 8.94342 6 9.8 6H17V4Z"
      fill="#202020"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.782 9.09202C19.5903 8.7157 19.2843 8.40973 18.908 8.21799C18.4802 8 17.9201 8 16.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.7157 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V16.8C8 17.9201 8 18.4802 8.21799 18.908C8.40973 19.2843 8.71569 19.5903 9.09202 19.782C9.51984 20 10.0799 20 11.2 20H16.8C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V11.2C20 10.0799 20 9.51984 19.782 9.09202ZM16.8 10H11.2C10.6069 10 10.2824 10.0016 10.0493 10.0206L10.0229 10.0229L10.0206 10.0493C10.0016 10.2824 10 10.6069 10 11.2V16.8C10 17.3931 10.0016 17.7176 10.0206 17.9507L10.0229 17.9771L10.0493 17.9794C10.2824 17.9984 10.6069 18 11.2 18H16.8C17.3931 18 17.7176 17.9984 17.9507 17.9794L17.9771 17.9771L17.9794 17.9507C17.9984 17.7176 18 17.3931 18 16.8V11.2C18 10.6069 17.9984 10.2824 17.9794 10.0493L17.9771 10.0229L17.9507 10.0206C17.7176 10.0016 17.3931 10 16.8 10Z"
      fill="#202020"
    />
  </svg>
</template>
